import { Component, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

import { ClientType } from '../_models/ClientType';

import { UserService } from '../_services/user.service';
import { PaymentService } from '../_services/payment-service.service';
import { ClientTypeCreateModalComponent } from './client-type-create-modal.component';


import { getUrl } from '../_shared/utils';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class AdministrationComponent implements OnInit {

    // Environment Variables
    baseUrl = getUrl();

    loading = false;
    editing = {};
    public clientTypes: ClientType[] = [];

    private bsModalRef: BsModalRef;

    constructor(
        private modalService: BsModalService,
        private userService: UserService,
        private spinner: NgxSpinnerService) { }

    ngOnInit() {
        this.spinner.show();
        this.userService.getAllClientTypes().subscribe(data => {
            this.clientTypes = data;
            this.clientTypes.forEach(clientType => {
                clientType['organizationName'] = '';
                clientType.organizations.forEach(organization => {
                    clientType['organizationName'] += organization.name +
                        (clientType.organizations.indexOf(organization) === clientType.organizations.length - 1 ? '' : ', ');
                });
            });
            this.loading = false;
            this.spinner.hide();
        });
    }

    addNewClientType() {
        this.openClientTypeCreationDialog(null);
    }

    editClientType(clientTypeId: number) {
        this.openClientTypeCreationDialog(clientTypeId);
    }

    private openClientTypeCreationDialog(clientTypeId?: number) {
        const modalConfig = {
            backdrop: true,
            ignoreBackdropClick: true
        };

        const initialState = {
            clientTypeId: clientTypeId
        };

        this.bsModalRef = this.modalService
            .show(
                ClientTypeCreateModalComponent,
                Object.assign({}, modalConfig, { class: 'modal-lg', initialState }));
    }



}
